import React, { useEffect, useLayoutEffect, memo, useContext, useState } from "react"
import ReactMarkdown from "react-markdown"
import gql from "graphql-tag"
import { useMediaPredicate } from "react-media-hook"

import { useStaticQuery, graphql, withAssetPrefix, Link, navigate } from "gatsby"
import { useLazyQuery, useMutation } from "@apollo/react-hooks"

import Layout from "../components/layout"
import SEO from "../components/seo"

import { LangContext } from "../context/LangContext"

import { SocialShare } from "../components/anti/social-links/social-links"
import { Button, ButtonGroup } from "../components/anti/buttons/buttons"
import { CoverContent, Cover } from "../components/anti/cover/cover"
import { AcfCoverMain } from "../components/gutenberg/acf-cover-main"
import { Card, CardProject } from "../components/anti/card/card"
import { CardSlider } from "../components/anti/card-slider/card-slider"
import { Feature } from "../components/anti/feature/feature"
import { Map, GoogleMapsEmbed } from "../components/anti/map/map"
import { Container, Section } from "../components/anti/grid/grid"
import { NavBottom } from "../components/anti/nav-bottom/nav-bottom"
import { HeadingLink } from "../components/anti/type/type"
import { LeadForm } from "../components/anti/lead-form/lead-form"
import { CalculatorFinance } from "../components/anti/calculator-finance/calculator-finance"
import { GliderVirtualLink } from "../components/anti/glider/glider"

import { replaceUnicode } from "../components/anti/utils/utils"
import linkIconShare from "../assets/img/icons/link_2x.png"
import { CDPTracker } from '../components/ads/CDPTracker'

import Modal from "react-modal"
import {GetMoreInfoForm} from '../components/anti/lead-form/get-more-info-form'

import "@glidejs/glide/dist/css/glide.core.min.css"
import "@glidejs/glide/dist/css/glide.theme.min.css"

const sapKey = process.env.SAP_API_KEY

const buttonScrollHandler = target => {
  var scrollContainer = target
  do {
    //find scroll container
    scrollContainer = scrollContainer.parentNode
    if (!scrollContainer) return
    scrollContainer.scrollTop += 1
  } while (scrollContainer.scrollTop == 0)

  var targetY = -60
  do {
    //find the top of target relatively to the container
    if (target == scrollContainer) break
    targetY += target.offsetTop
  } while ((target = target.offsetParent))

  const scroll = function(c, a, b, i) {
    i++
    if (i > 30) return
    c.scrollTop = a + ((b - a) / 30) * i
    setTimeout(function() {
      scroll(c, a, b, i)
    }, 20)
  }
  // start scrolling
  scroll(scrollContainer, scrollContainer.scrollTop, targetY, 0)
}

const Shortcodes = ({
  data,
  nearbyData,
  eBrochure,
  name,
  lang,
  eCatalogUrl,
  propertyTypesProject,
  projectData,
  contentIds,
  thisUrl,
}) => {
  const nearbyProjects = nearbyData && nearbyData.projects.nodes
  const eBrochureProject =
    eBrochure !== undefined &&
    eBrochure.eBrochureBy !== null &&
    eBrochure.eBrochureBy.eBrochure.file.mediaItemUrl

  if (data.attributes.text === "nearby") {
    return nearbyData ? (
      <Section>
        <Container>
          <h2 className="mb-3">Nearby</h2>
        </Container>
        <Container className="px-sm-down-0">
          <CardSlider
            showInitial={3}
            showLgDown={1}
            showMdDown={1}
            showSmDown={1}
            arrowsInitial={true}
            arrowsLgDown={true}
            arrowsMdDown={true}
            arrowsSmDown={true}
          >
            {nearbyProjects &&
              nearbyProjects.map((project, i) => {
                const colHeadline = project.blocks.find(
                  x => x.name === "acf/col-headline"
                )
                const description = colHeadline && colHeadline.colHeadline.text
                const propertyTypes = project.propertyTypes.nodes[0].name
                return (
                  <CardProject
                    title={project.title}
                    description={description}
                    img={
                      project.featuredImage && project.featuredImage.sourceUrl
                    }
                    category={propertyTypes}
                    className="ratio-1-1"
                    link={`/development/${project.propertyTypes.nodes[0].slug}/${project.slug}`}
                  />
                )
              })}
          </CardSlider>
        </Container>
      </Section>
    ) : (
      <div></div>
    )
  } else if (data.attributes.text === "calculator-finance") {
    const slug = projectData.slug ? projectData.slug : ""
    const projectTypes = projectData.propertyTypes
      ? projectData.propertyTypes?.nodes?.[0].slug
      : ""
    return (
      <div id="fin-pro">
        <CalculatorFinance key={`calculator-finance`} />
        <Section>
          <Container>
            <div className="row">
              <div className="col-md-6 col-12 mb-3">
                <h5>
                  {lang === "EN"
                    ? "Compare units and find your ideal residence!"
                    : "Bandingkan unit dan temukan hunian ideal Anda!"}
                </h5>
              </div>
              <div className="col-md-6 col-12 d-flex justify-content-center align-items-center">
                <Button
                  variant="secondary btn-p-all"
                  link={`/compare-unit?propertyTypes=${projectTypes}&slug=${slug}`}
                >
                  {lang === "EN" ? "Compare Unit " : "Bandingkan unit"}{" "}
                  <i className="fas fa-arrow-right ml-1"></i>
                </Button>
              </div>
            </div>
          </Container>
        </Section>
      </div>
    )
  } else if (data.attributes.text === "lead-form") {
    const {
      clusterCode,
      projectsCode,
      leadSourceName,
    } = projectData.projectCustomfields ? projectData.projectCustomfields : {}
    return (
      <LeadForm
        name={name}
        projectData={projectData}
        clusterCode={clusterCode}
        leadSourceName={leadSourceName}
        projectCode={projectsCode}
        propertyTypesProject={propertyTypesProject}
        contentIds={contentIds}
        thisUrleCatalog={thisUrl}
      />
    )
  } else if (data.attributes.text === "e-brochure") {
    if (eBrochureProject) {
      return (
        <Section>
          <Container>
            <div className="row">
              <div className="col-md-6 col-12 mb-3">
                <h5>
                  {lang === "EN"
                    ? "Let's calculate the estimated cost of your dream property."
                    : "Ayo hitung perkiraan biaya properti impian Anda."}
                </h5>
              </div>
              <div className="col-md-6 col-12 d-flex justify-content-center align-items-center">
                <Button
                  variant="secondary btn-p-all"
                  onClick={() =>
                    buttonScrollHandler(document.getElementById("fin-pro"))
                  }
                >
                  {lang === "EN" ? "Calculate here" : "Hitung disini"}{" "}
                  <i className="fas fa-arrow-right ml-1"></i>
                </Button>
                {/* <Button variant="secondary btn-p-all" 
                  // link={eBrochureProject}
                  onClick={() => {
                    window.dataLayer = window.dataLayer || []
                    window.dataLayer.push({
                      event: "DownloadBrochure",
                      page_url: window.location.href,
                      page_title: name,
                      content_type: "home_listing",
                      content_ids: contentIds,
                      city: "bsd-city",
                      region: "bsd-city",
                      country: "Indonesia",
                    })
                    window.open(eBrochureProject, "_blank")
                  }}
                >
                  {lang === "EN" ? "e-Brochure" : "e-Brosur"}{" "}
                  <i className="fas fa-arrow-right ml-1"></i>
                </Button> */}
                &nbsp;&nbsp;&nbsp;
                {/* <a
                  href={eCatalogUrl}
                  target={eCatalogUrl !== "#" ? "_blank" : "_self"}
                  className="btn btn-secondary btn-p-all"
                  rel="noopener noreferrer"
                >
                  e-Catalog&nbsp;
                  <i className="fas fa-arrow-right ml-1"></i>
                </a> */}
              </div>
            </div>
          </Container>
        </Section>
      )
    } else {
      return (
        <Section>
          <Container>
            <div className="row">
              <div className="col-md-6 col-12 mb-3">
                <h5>
                  {lang === "EN"
                    ? "Let's calculate the estimated cost of your dream property."
                    : "Ayo hitung perkiraan biaya properti impian Anda."}
                </h5>
              </div>
              <div className="col-md-6 col-12 d-flex justify-content-center align-items-center">
                <Button
                  variant="secondary btn-p-all"
                  onClick={() =>
                    buttonScrollHandler(document.getElementById("fin-pro"))
                  }
                >
                  {lang === "EN" ? "Calculate here" : "Hitung disini"}{" "}
                  <i className="fas fa-arrow-right ml-1"></i>
                </Button>
                {/* <Button variant="secondary btn-p-all" link="#">
                  {lang === "EN" ? "e-Brochure" : "e-Brosur"}{" "}
                  <i className="fas fa-arrow-right ml-1"></i>
                </Button> */}
                &nbsp;&nbsp;&nbsp;
                {/* <Button
                  className="btn btn-secondary btn-p-all"
                  onClick={eCatalogUrl}
                >
                  e-Catalog
                </Button> */}
              </div>
            </div>
          </Container>
        </Section>
      )
    }
  }
  return data.attributes.text
}

const Blocks = memo(
  ({ wp, nearbyData, iconList, props, eBrochure, propertyTypesActive }) => {
    return wp.blocks.map((block, i) => {
      // propertyTypesActive === "residential" && (
      //   <CalculatorFinance key={`calculator-finance`} />
      // )
      switch (block.name) {
        case "acf/cover-main":
          return (
            <AcfCoverMain
              data={block}
              key={`${block.name}${i}`}
              breadcrumb={props.location.pathname}
            />
          )

        case "acf/col-headline":
          return (
            <Section className="bg-light">
              <Container className="">
                <div className="row">
                  <div className="col-lg-6 col-xl-5 pr-4">
                    <h2 className="h2">
                      {block.colHeadline &&
                        block.colHeadline.title &&
                        replaceUnicode(block.colHeadline.title)}
                    </h2>
                  </div>
                  <div className="col-lg-6 col-xl-7">
                    <p>
                      {
                        // block.colHeadline && block.colHeadline.text
                        <ReactMarkdown
                          source={block.colHeadline.text}
                          escapeHtml={false}
                        />
                      }
                    </p>
                    {/* On FUTURE DEVELOPMENT details pages only */}
                    {block.colHeadline.additionalInfo != null ? (
                      <>
                        <div className="mt-5">
                          <p class="h4 mb-3 text-gray-600">
                            {block.colHeadline.additionalInfo[0].label}
                          </p>
                          <p>{block.colHeadline.additionalInfo[0].value}</p>
                        </div>
                        {block.colHeadline.buttons != null ? (
                          <Button
                            variant="link"
                            to={block.colHeadline.buttons[0].url}
                          >
                            {block.colHeadline.buttons[0].text}
                          </Button>
                        ) : null}
                      </>
                    ) : null}
                  </div>
                </div>
              </Container>
            </Section>
          )

        case "acf/image-slider":
          if (block.imageSlider && block.imageSlider.images !== null) {
            return (
              <Section>
                <Container>
                  <HeadingLink>
                    <h2 className="h3">
                      {block.imageSlider && block.imageSlider.title}
                    </h2>
                    <Button variant="link">
                      {block.imageSlider && block.imageSlider.link.text}
                    </Button>
                  </HeadingLink>
                  <CardSlider
                    showInitial={6}
                    showLgDown={5}
                    showMdDown={4}
                    showSmDown={3.5}
                  >
                    {block.imageSlider &&
                      block.imageSlider.images.length > 0 &&
                      block.imageSlider.images.map((item, i) => {
                        return (
                          <Card
                            variant="boxless"
                            img={item.img && item.img.mediaItemUrl}
                            imgHeight="h-ratio-1-1"
                          />
                        )
                      })}
                  </CardSlider>
                </Container>
              </Section>
            )
          }

        case "acf/acfgallery":
          return (
            <Section
              className={`${block.acfBlockGallery &&
                block.acfBlockGallery.bgColor} ${block.attributes &&
                block.attributes.className}`}
            >
              <Container className="px-sm-down-0">
                <CardSlider
                  // fade
                  noGutter
                  showInitial={1}
                  showLgDown={1}
                  showMdDown={1}
                  showSmDown={1}
                  visibleInitial={false}
                  visibleLgDown={false}
                  arrowsLgDown={true}
                  arrowsMdDown={true}
                  arrowsSmDown={true}
                >
                  {block.acfBlockGallery &&
                    block.acfBlockGallery.images &&
                    block.acfBlockGallery.images.map((item, i) => {
                      return (
                        <Card
                          variant="boxless"
                          img={item.mediaItemUrl}
                          imgHeight="h-ratio-2-1"
                          key={i}
                        />
                      )
                    })}
                </CardSlider>
              </Container>
            </Section>
          )

        case "acf/map-with-features":
          return (
            <>
              <Section className="map-w-features p-0">
                <div className="row row-0">
                  <div className="col-md-7">
                    {wp?.embedProjectsLocation?.embedUrl && (
                      <GoogleMapsEmbed
                        embedUrl={wp?.embedProjectsLocation?.embedUrl}
                      />
                    )}
                    {/* {block?.MapWFeatures?.location?.longitude &&
                      block?.MapWFeatures?.location?.latitude && (
                        <Map
                          long={
                            block?.MapWFeatures?.location &&
                            parseFloat(block?.MapWFeatures?.location?.longitude)
                          }
                          lat={
                            block?.MapWFeatures?.location &&
                            parseFloat(block?.MapWFeatures?.location?.latitude)
                          }
                          zoom={16}
                        />
                      )} */}
                  </div>
                  <div className="col-md-5 py-main-sm px-md-4 bg-secondary">
                    <Container className="features-top">
                      <h2 className="h2">
                        {block.MapWFeatures && block.MapWFeatures.title}
                      </h2>
                      <ul>
                        {block.MapWFeatures.featuresTop &&
                          block.MapWFeatures.featuresTop.map((item, i) => {
                            return (
                              <li key={i}>
                                <Feature title={item.name} text={item.text} />
                              </li>
                            )
                          })}
                      </ul>
                    </Container>
                  </div>
                </div>
              </Section>
              <Section>
                <Container className="features-bottom">
                  <div className="row row-3">
                    {block.MapWFeatures.featuresBottom &&
                      block.MapWFeatures.featuresBottom.length > 0 &&
                      block.MapWFeatures.featuresBottom.map((item, i) => {
                        return (
                          <div className="col-md-6" key={i}>
                            <Feature title={item.name} text={item.text} />
                          </div>
                        )
                      })}
                  </div>
                </Container>
              </Section>
            </>
          )

        case "acf/iconlist":
          const iconListBlock = iconList?.project?.blocks.find(
            item => item.name === "acf/iconlist"
          )
          return (
            <Section
              className={`${block.acfBlockIconList &&
                block.acfBlockIconList.bgColor} ${block.acfBlockIconList &&
                block.attributes.className}`}
            >
              <Container>
                <div className="mb-4">
                  <h2 className="h2">
                    {block.acfBlockIconList && block.acfBlockIconList.title}
                  </h2>
                  <p className="mb-0">
                    {block.acfBlockIconList && block.acfBlockIconList.text}
                  </p>
                </div>
                <div className="row mb-n2">
                  {iconListBlock?.acfBlockIconList?.list &&
                    iconListBlock?.acfBlockIconList?.list.length > 0 &&
                    iconListBlock?.acfBlockIconList?.list.map((item, i) => {
                      return (
                        <div className="col-12 col-md-4 col-lg">
                          <Feature
                            img={item.icon && item.icon.mediaItemUrl}
                            title={item.title && item.title}
                            titleClassName="mb-2 mt-sm-down-1"
                            text={item.description && item.description}
                            key={i}
                          />
                        </div>
                      )
                    })}
                </div>
              </Container>
            </Section>
          )

          {
            /* case "acf/instagram":
        return (
          <Instagram
            title={block.instagram.title}
            bgColor={block.instagram.bgColor}
            className={block.attributes.className}
          />
        ); */
          }

        case "acf/cover-content":
          return (
            <>
              {/* <Section>
            <Container>
              <h2 className="h3">Nearby</h2>
              <CardSlider showInitial={3} showLgDown={3} showMdDown={2}>
                <Card
                  variant="overlay"
                  title="AEON Mall"
                  titleClassName="h5"
                  text="Shop & Dine"
                  img={data.imgCover.childImageSharp.fluid}
                  imgHeight="h-ratio-1-1"
                />
                <Card
                  variant="overlay"
                  title="BSD Green Office"
                  titleClassName="h5"
                  text="Office"
                  img={data.imgCover.childImageSharp.fluid}
                  imgHeight="h-ratio-1-1"
                />
                <Card
                  variant="overlay"
                  title="The Breeze"
                  titleClassName="h5"
                  text="Shop & Dine"
                  img={data.imgCover.childImageSharp.fluid}
                  imgHeight="h-ratio-1-1"
                />
                <Card
                  variant="overlay"
                  title="AEON Mall"
                  titleClassName="h5"
                  text="Shop & Dine"
                  img={data.imgCover.childImageSharp.fluid}
                  imgHeight="h-ratio-1-1"
                />
                <Card
                  variant="overlay"
                  title="AEON Mall"
                  titleClassName="h5"
                  text="Shop & Dine"
                  img={data.imgCover.childImageSharp.fluid}
                  imgHeight="h-ratio-1-1"
                />
                <Card
                  variant="overlay"
                  title="AEON Mall"
                  text="Shop & Dine"
                  img={data.imgCover.childImageSharp.fluid}
                  imgHeight="h-ratio-1-1"
                />
              </CardSlider>
            </Container>
          </Section> */}
              {propertyTypesActive === "residential" && (
                <div id="fin-pro">
                  <CalculatorFinance key={`calculator-finance`} />
                </div>
              )}
              <CoverContent
                theme="dark"
                img={
                  block.coverContent &&
                  block.coverContent.img &&
                  block.coverContent.img.sourceUrl
                }
                imgOverlay="20"
                className={`mb-n2 ${block.coverContent.bgColor || ""} ${block
                  .attributes.className || ""}`}
              >
                <h2 className="h2">{block.coverContent.title || ""}</h2>
                <p>{block.coverContent.text || ""}</p>
                {block.coverContent.buttons && (
                  <ButtonGroup>
                    {block.coverContent.buttons.length > 0 &&
                      block.coverContent.buttons.map((item, i) => {
                        return (
                          <Button
                            variant="link"
                            link={item.link && item.link.url}
                            target={item.link && item.link.target}
                            key={i}
                          >
                            {item.text}
                          </Button>
                        )
                      })}
                  </ButtonGroup>
                )}
              </CoverContent>
            </>
          )

        case "core/shortcode":
          return (
            <Shortcodes
              data={block}
              nearbyData={nearbyData}
              eBrochure={eBrochure}
              name={wp.title}
              key={`shortcode${i}`}
              propertyTypesActive={propertyTypesActive}
            />
          )
      }
    })
  }
)

const ButtonWADesktop = ({onClick})=>{
  return (
    <div className="container position-absolute mx-auto d-none d-md-flex justify-content-end" style={{bottom: '10px', left: 0, right: 0}}>
      <button 
        onClick={onClick} 
        className="btn btn-primary d-flex align-items-center" 
        style={{
          gap: '4px',
          backgroundColor: "#203091",
          color: "white",
          border: "none",
          borderRadius: "10px",
          padding: "8px 14px",
          boxShadow: "0 8px 20px rgba(0,0,0,0.45)"
        }}>
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M19.05 4.91A9.82 9.82 0 0 0 12.04 2c-5.46 0-9.91 4.45-9.91 9.91c0 1.75.46 3.45 1.32 4.95L2.05 22l5.25-1.38c1.45.79 3.08 1.21 4.74 1.21c5.46 0 9.91-4.45 9.91-9.91c0-2.65-1.03-5.14-2.9-7.01m-7.01 15.24c-1.48 0-2.93-.4-4.2-1.15l-.3-.18l-3.12.82l.83-3.04l-.2-.31a8.26 8.26 0 0 1-1.26-4.38c0-4.54 3.7-8.24 8.24-8.24c2.2 0 4.27.86 5.82 2.42a8.18 8.18 0 0 1 2.41 5.83c.02 4.54-3.68 8.23-8.22 8.23m4.52-6.16c-.25-.12-1.47-.72-1.69-.81c-.23-.08-.39-.12-.56.12c-.17.25-.64.81-.78.97c-.14.17-.29.19-.54.06c-.25-.12-1.05-.39-1.99-1.23c-.74-.66-1.23-1.47-1.38-1.72c-.14-.25-.02-.38.11-.51c.11-.11.25-.29.37-.43s.17-.25.25-.41c.08-.17.04-.31-.02-.43s-.56-1.34-.76-1.84c-.2-.48-.41-.42-.56-.43h-.48c-.17 0-.43.06-.66.31c-.22.25-.86.85-.86 2.07s.89 2.4 1.01 2.56c.12.17 1.75 2.67 4.23 3.74c.59.26 1.05.41 1.41.52c.59.19 1.13.16 1.56.1c.48-.07 1.47-.6 1.67-1.18c.21-.58.21-1.07.14-1.18s-.22-.16-.47-.28"/></svg>
        <span>Whatsapp</span>
      </button>
    </div>
  )}

const DevelopmentDetails = ({ location, pageContext, pathContext }) => {
  const { lang, setLang } = useContext(LangContext)
  const [loginEmail, setLoginEmail] = useState(null)
  const [loginMobile, setLoginMobile] = useState(null)
  const [loginC4CID, setLoginC4CID] = useState(null)
  const [lastName, setLastName] = useState(null)
  const data = useStaticQuery(graphql`
    query StaticData {
      imgCover: file(relativePath: { eq: "sample/bg_rectangle-dark-2.jpg" }) {
        id
        name
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      }
      wordPress {
        propertyTypes {
          nodes {
            name
            slug
            projects {
              nodes {
                title
                slug
                blocks {
                  ... on WordPress_AcfCoverMainBlock {
                    name
                    attributes {
                      className
                    }
                    coverMain {
                      img {
                        mediaItemUrl
                      }
                      imgOverlay
                      label
                      title
                      text
                      buttons {
                        text
                        link {
                          target
                          url
                        }
                      }
                    }
                  }
                }
                seo {
                  title
                  metaDesc
                  twitterDescription
                  opengraphDescription
                }
              }
            }
          }
        }
      }
    }
  `)

  const GET_NEARBY_PROJECT = gql`
    query NearbyProjects($id: [ID]) {
      projects(where: { in: $id }) {
        nodes {
          title
          slug
          featuredImage {
            id
            title
            sourceUrl
            caption
          }
          propertyTypes {
            nodes {
              name
              slug
            }
          }
          blocks {
            ... on AcfCoverMainBlock {
              name
              attributes {
                className
              }
              coverMain {
                img {
                  mediaItemUrl
                }
                imgOverlay
                label
                title
                text
                buttons {
                  text
                  link {
                    target
                    url
                  }
                }
              }
            }
            ... on AcfColHeadlineBlock {
              name
              attributes {
                className
              }
              colHeadline {
                bgColor
                title
                text
                additionalInfo {
                  label
                  value
                }
                buttons {
                  text
                  link {
                    target
                    url
                  }
                }
                list {
                  text
                  icon {
                    sourceUrl
                  }
                }
              }
            }
          }
        }
      }
    }
  `

  const GET_BLOCKS = gql`
    query GetBlocks($id: ID!) {
      project(id: $id, idType: URI) {
        slug
        blocks {
          name
          ... on AcfIconlistBlock {
            name
            attributes {
              className
            }
            acfBlockIconList {
              bgColor
              title
              text
              list {
                icon {
                  mediaItemUrl
                }
                title
                description
                link {
                  url
                }
              }
            }
          }
        }
      }
    }
  `
  const GET_EBROCHURE = gql`
    query brochure($id: String) {
      eBrochureBy(uri: $id) {
        eBrochure {
          file {
            mediaItemUrl
          }
        }
      }
    }
  `

  const wp = pageContext.data
  const wpID =
    pageContext.data.translation && pageContext.data.translation.blocks
  const slug = pathContext.data.slug
  const contentIds = slug.replace(/-/g, "_")
  const propertyTypesName = pageContext.propertyTypesName
  const resizeScreen = useMediaPredicate("(max-width: 992px)")

  const [getNearby, { data: nearbyData }] = useLazyQuery(GET_NEARBY_PROJECT)
  const [getIconList, { data: iconList }] = useLazyQuery(GET_BLOCKS)

  const [isShowMore, setIsShowMore] = useState(false)
  const [isOpenModalWA, setIsOpenModalWA] = useState(false)

  const { clusterCode = '', leadSourceName = '', projectsCode = ''} = wp?.projectCustomfields

  const handleCloseModalWA = ()=>{
    setIsOpenModalWA(false)
  }
  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
    },
  }
  const [isGigyaReady, setIsGigyaReady] = useState(false);

  // Modify navbar style
  useLayoutEffect(() => {
    const navbar = document.querySelector(".navbar")
    navbar.classList.remove("transparent")
    navbar.classList.replace("dark", "light")
  }, [])

  useEffect(() => {
    if (wp.nearby !== undefined && wp.nearby.length > 0) {
      getNearby({ variables: { id: wp.nearby } })
    }
    // if (wp.nearby.length > 0) {
    //   getNearby({ variables: { id: wp.nearby } })
    // }

    const iconListExists = wp.blocks.find(item => item.name === "acf/iconlist")
    if (iconListExists) {
      getIconList({
        variables: {
          id: pageContext.data.slug,
        },
      })
    }
  }, [])

  useEffect(() => {
    const checkGigya = setInterval(() => {
      if (window.gigya?.accounts?.getAccountInfo) {
        setIsGigyaReady(true);
        clearInterval(checkGigya);
      }
    }, 100); // Check every 100ms

    // Cleanup
    return () => clearInterval(checkGigya);
  }, []);

  useEffect(() => {
    if (isGigyaReady) {
      window.gigya.accounts.getAccountInfo({
        extraProfileFields: "phones",
        callback: (res) => {
          setLoginEmail(res.profile?.email);
          setLoginMobile(res.profile?.phones?.number?.replace(/\D/g, '') || null);
          setLoginC4CID(res.data?.C4C_BPID);
          setLastName(res.profile?.lastName);
        }
      });
    }
  }, [isGigyaReady]);

  const currentType =
    wp.propertyTypes.nodes[0] &&
    wp.propertyTypes.nodes[0].slug &&
    wp.propertyTypes.nodes[0].slug
  const propertyTypes = data.wordPress.propertyTypes.nodes
  const projectsByType =
    propertyTypes.find(x => x.slug === currentType) &&
    propertyTypes.find(x => x.slug === currentType).projects.nodes
  const currentIndex =
    currentType && projectsByType.findIndex(x => x.slug === wp.slug)

  const thisBlocks =
    lang === "EN"
      ? pageContext?.data?.blocks
      : pageContext?.data?.translation?.blocks

  let listBlocks = []

  thisBlocks?.map(item => {
    listBlocks.push(item.name)
  })

  const eCatalogProject = wp?.ecatalogUrl?.ecatalogUrl

  const handleCopy = () => {
    const thisInput = document.createElement("INPUT")

    document.body.append(thisInput)
    thisInput.value = location.href
    thisInput.select()
    document.execCommand("copy")
    thisInput.remove()
    setTimeout(function() {
      document.getElementById(
        "copyButton"
      ).innerHTML = `<img src=${linkIconShare} /> <span class="tooltiptext">${
        lang === "EN" ? "URL has copied" : "Tautan telah disalin"
      }</span>`
    }, 200)
    setTimeout(function() {
      document.getElementById(
        "copyButton"
      ).innerHTML = `<img src=${linkIconShare} />`
    }, 2000)
  }

  useEffect(() => {
    if (listBlocks.includes("core/embed")) {
      if (resizeScreen) {
        document.querySelector(".cover-full")?.style.setProperty("margin-top", "0px");
        document.querySelector(".py-main.bg-white")?.style.setProperty("padding-bottom", "5px");
        document.querySelector(".cover-bg-wrapper")?.style.setProperty("overflow", "unset");
      }
      // }else{
      //   // document.querySelector(".cover-full").style.marginTop = "0px"
      //   // document.querySelector(".py-main.bg-white").style.paddingBottom = "5px"
      // }
    }
  }, [])

  useEffect(() => {
    productDetailDataLayer()
  }, [])

  const [getBrochure, { data: eBrochure }] = useLazyQuery(GET_EBROCHURE)

  useEffect(() => {
    getBrochure({
      variables: {
        id: slug,
      },
    })
  }, [])

  const nextProject = () => {
    if (projectsByType[currentIndex + 1] !== undefined) {
      return projectsByType[currentIndex + 1]
    } else {
      return projectsByType[projectsByType[0]]
    }
  }

  const prevProject = () => {
    if (projectsByType[currentIndex - 1] !== undefined) {
      return projectsByType[currentIndex - 1]
    } else {
      return projectsByType[projectsByType.length - 1]
    }
  }

  const changeNullToBeZero = val => {
    if (val == null) return 0
    return val
  }

  const setDataLayerValue = event => {
    const value = {
      event: event,
      page_url: typeof window !== "undefined" ? window.location.href : "",
      page_title: wp?.title,
      content_type: "home_listing",
      content_ids: contentIds,
      city: "bsd-city",
      region: "bsd-city",
      country: "Indonesia",
      lease_start_date: "2021-01-01",
      lease_end_date: "2100-01-01",
      currency: "IDR",
      preferred_price_range: [
        wp?.projectCustomfields?.preferredPriceRangeFrom,
        wp?.projectCustomfields?.preferredPriceRangeTo,
      ],
      preferred_baths_range: [
        changeNullToBeZero(wp?.projectCustomfields?.preferredBathsRangeFrom),
        changeNullToBeZero(wp?.projectCustomfields?.preferredBathsRangeTo),
      ],
      preferred_bed_range: [
        changeNullToBeZero(wp?.projectCustomfields?.preferredBedRangeFrom),
        changeNullToBeZero(wp?.projectCustomfields?.preferredBedRangeTo),
      ],
      property_type: propertyTypesName,
    }
    return value
  }

  const setDetailWFHDataLayer = value => {
    if (typeof window !== "undefined") {
      window.dataLayer = window.dataLayer || []
      window.dataLayer.push(value)
    }
  }

  const productDetailDataLayer = () => {
    setDetailWFHDataLayer(setDataLayerValue("ViewContent"))
  }

  const { seo } = lang === "EN" ? wp : wp.translation || wp
  const SEODefaultImg =
    lang === "EN"
      ? wp?.blocks[0]?.coverMain?.img?.mediaItemUrl
      : wp?.translation?.blocks[0]?.coverMain?.img?.mediaItemUrl ||
        wp?.blocks[0]?.coverMain?.img?.mediaItemUrl
  const featuredImage =
    lang === "EN"
      ? wp?.featuredImage?.sourceUrl
      : wp?.translation?.featuredImage?.sourceUrl ||
        wp?.featuredImage?.sourceUrl
  const thisUrl = process.env.BASE_URL + location.pathname

  const schemaDetailProjects = [
    {
      "@context": "https://schema.org/",
      "@type": "Product",
      name: wp?.title,
      description: seo?.metaDesc,
      review: {
        "@type": "Review",
        reviewRating: {
          "@type": "Rating",
          ratingValue: "5",
          bestRating: "5",
        },
        author: {
          "@type": "Organization",
          name: "Sinar Mas Land",
        },
      },
    },
  ]


  const handleOpenWA = async (whatsappUrl) => {
    // 1️⃣ Safari iPhone: buka tab dummy dulu
    const newTab = window.open("about:blank", "_blank");

    try {
      // 3️⃣ Cek newTab bukan null sebelum assign
      if (newTab) {
        newTab.location.href = whatsappUrl;
      } else {
        // fallback jika Safari mem-block popup
        window.location.href = whatsappUrl;
    }
    } catch (err) {
      console.error("❌ ERROR:", err);

      // Tutup tab jika gagal
      if (newTab) newTab.close();
    }
  };

  return (
    <>
    <Layout isMicrodataProduct={true}>
      <SEO
        title={seo?.title}
        desc={seo?.metaDesc}
        fbImg={featuredImage}
        fbTitle={seo?.opengraphTitle || seo?.title}
        fbDesc={seo?.opengraphDescription}
        url={thisUrl}
        twitterTitle={seo?.twitterTitle || seo?.title}
        twitterDesc={seo?.twitterDescription}
        twitterImg={featuredImage}
        // schemaMarkup={schemaDetailProjects}
      />

      {lang === "ID" &&
        wpID &&
        wpID.map((block, i) => {
          switch (block.name) {
            case "core/embed":
              return (
                <Cover
                  type={{ name: "core-embed/youtube" }}
                  theme="dark"
                  imgHeight="h-400px h-md-500px w-100"
                  imgOverlay="40"
                  className="cover cover-full-top"
                  videoSrc={block.attributes.url}
                  // imgOverlay="30"
                  // imgHeight="h-500px h-md-600px w-100"
                  // className="cover-full cover-main"
                />
              )
            case "acf/cover-main":
              return (
                <>
                  <div className="position-relative">
                    <AcfCoverMain
                      data={block}
                      key={`${block.name}${i}`}
                      breadcrumb={location.pathname}
                    />
                    <ButtonWADesktop onClick={()=>setIsOpenModalWA(true)} />
                  </div>
                  <section className="py-main pt-3 pb-3 bg-light social-dev-wrapper">
                    <div className="container">
                      <div className="row">
                        <div className="col-lg-12 col-xl-12">
                          <SocialShare link={thisUrl} onClick={handleCopy} />
                        </div>
                      </div>
                    </div>
                  </section>
                  <div>
                    <meta itemProp="mpn" content="925872" />
                    <meta itemProp="name" content={seo?.title} />
                    <link
                      itemProp="image"
                      href={block?.coverMain?.img?.mediaItemUrl}
                    />
                    <meta
                      itemProp="description"
                      content={seo?.opengraphDescription}
                    />
                    <div
                      itemProp="offers"
                      itemType="https://schema.org/AggregateOffer"
                      itemScope
                    >
                      <meta itemProp="lowPrice" content="0" />
                      <meta itemProp="highPrice" content="0" />
                      <meta itemProp="offerCount" content="10" />
                      <meta itemProp="priceCurrency" content="IDR" />
                    </div>
                    <div
                      itemProp="review"
                      itemType="https://schema.org/Review"
                      itemScope
                    >
                      <div
                        itemProp="author"
                        itemType="https://schema.org/Person"
                        itemScope
                      >
                        <meta itemProp="name" content="Sinar Mas Land" />
                      </div>
                      <div
                        itemProp="reviewRating"
                        itemType="https://schema.org/Rating"
                        itemScope
                      >
                        <meta itemProp="ratingValue" content="4.5" />
                        <meta itemProp="bestRating" content="5" />
                      </div>
                    </div>
                    <meta itemProp="sku" content="0446310786" />
                    <div
                      itemProp="brand"
                      itemType="https://schema.org/Brand"
                      itemScope
                    >
                      <meta itemProp="name" content="BSD City" />
                    </div>
                  </div>
                </>
              )

            case "acf/col-headline":
              return (
                <Section className="bg-light">
                  <Container className="">
                    <div className="row">
                      <div className="col-lg-6 col-xl-5 pr-4">
                        <h2 className="h2">
                          {block.colHeadline &&
                            block.colHeadline.title &&
                            replaceUnicode(block.colHeadline.title)}
                        </h2>
                      </div>
                      <div className="col-lg-6 col-xl-7">
                        <div className={`mb-3 ${isShowMore ? '' : 'line-clamp-3'}`}>
                          {
                            // block.colHeadline && block.colHeadline.text
                            <ReactMarkdown
                              source={block.colHeadline.text}
                              escapeHtml={false}
                            />
                          }
                        </div>
                        <button onClick={()=> setIsShowMore((prev)=>!prev)} className="btn btn-link text-secondary">
                          {isShowMore ? 'Hide' : 'Show More'}
                        </button>
                        {/* On FUTURE DEVELOPMENT details pages only */}
                        {block.colHeadline.additionalInfo != null ? (
                          <>
                            <div className="mt-5">
                              <p class="h4 mb-3 text-gray-600">
                                {block.colHeadline.additionalInfo[0].label}
                              </p>
                              <p>{block.colHeadline.additionalInfo[0].value}</p>
                            </div>
                            {block.colHeadline.buttons != null ? (
                              <Button
                                variant="link"
                                to={block.colHeadline.buttons[0].url}
                              >
                                {block.colHeadline.buttons[0].text}
                              </Button>
                            ) : null}
                          </>
                        ) : null}
                      </div>
                    </div>
                  </Container>
                </Section>
              )

            case "acf/image-slider":
              if (block.imageSlider && block.imageSlider.images !== null) {
                return (
                  <Section>
                    <Container>
                      <HeadingLink>
                        <h2 className="h3">
                          {block.imageSlider && block.imageSlider.title}
                        </h2>
                        <Button variant="link">
                          {block.imageSlider && block.imageSlider.link.text}
                        </Button>
                      </HeadingLink>
                      <CardSlider
                        showInitial={6}
                        showLgDown={5}
                        showMdDown={4}
                        showSmDown={3.5}
                      >
                        {block.imageSlider &&
                          block.imageSlider.images.length > 0 &&
                          block.imageSlider.images.map((item, i) => {
                            return (
                              <Card
                                variant="boxless"
                                img={item.img && item.img.mediaItemUrl}
                                imgHeight="h-ratio-1-1"
                              />
                            )
                          })}
                      </CardSlider>
                    </Container>
                  </Section>
                )
              }

            case "acf/acfgallery":
              return (
                <Section
                  className={`${block.acfBlockGallery &&
                    block.acfBlockGallery.bgColor} ${block.attributes &&
                    block.attributes.className}`}
                >
                  <Container className="px-sm-down-0">
                    <CardSlider
                      // fade
                      noGutter
                      showInitial={1}
                      showLgDown={1}
                      showMdDown={1}
                      showSmDown={1}
                      visibleInitial={false}
                      visibleLgDown={false}
                      arrowsLgDown={true}
                      arrowsMdDown={true}
                      arrowsSmDown={true}
                    >
                      {block.acfBlockGallery &&
                        block.acfBlockGallery.images &&
                        block.acfBlockGallery.images.map((item, i) => {
                          return (
                            <Card
                              variant="boxless"
                              img={item.sourceUrl}
                              imgHeight="h-ratio-2-1"
                              key={i}
                            />
                          )
                        })}
                    </CardSlider>
                  </Container>
                </Section>
              )

            case "acf/map-with-features":
              return (
                <>
                  <Section className="map-w-features p-0">
                    <div className="row row-0">
                      <div className="col-md-7">
                        <GoogleMapsEmbed
                          embedUrl={wpID?.embedProjectsLocation?.embedUrl}
                        />
                        {/* <Map
                          long={
                            block.MapWFeatures.location &&
                            parseFloat(block.MapWFeatures.location.longitude)
                          }
                          lat={
                            block.MapWFeatures.location &&
                            parseFloat(block.MapWFeatures.location.latitude)
                          }
                          zoom={16}
                        /> */}
                      </div>
                      <div className="col-md-5 py-main-sm px-md-4 bg-secondary">
                        <Container className="features-top">
                          <h2 className="h2">
                            {block.MapWFeatures && block.MapWFeatures.title}
                          </h2>
                          <ul>
                            {block.MapWFeatures.featuresTop &&
                              block.MapWFeatures.featuresTop.map((item, i) => {
                                return (
                                  <li key={i}>
                                    <Feature
                                      title={item.name}
                                      text={item.text}
                                    />
                                  </li>
                                )
                              })}
                          </ul>
                        </Container>
                      </div>
                    </div>
                  </Section>
                  <Section>
                    <Container className="features-bottom">
                      <div className="row row-3">
                        {block.MapWFeatures.featuresBottom &&
                          block.MapWFeatures.featuresBottom.length > 0 &&
                          block.MapWFeatures.featuresBottom.map((item, i) => {
                            return (
                              <div className="col-md-6" key={i}>
                                <Feature title={item.name} text={item.text} />
                              </div>
                            )
                          })}
                      </div>
                    </Container>
                  </Section>
                </>
              )

            case "acf/iconlist":
              return (
                <Section
                  className={`${block.acfBlockIconList &&
                    block.acfBlockIconList.bgColor} ${block.acfBlockIconList &&
                    block.attributes.className}`}
                >
                  <Container>
                    <div className="mb-4">
                      <h2 className="h2">
                        {block.acfBlockIconList && block.acfBlockIconList.title}
                      </h2>
                      <p className="mb-0">
                        {block.acfBlockIconList && block.acfBlockIconList.text}
                      </p>
                    </div>
                    <div className="row mb-n2">
                      {block?.acfBlockIconList?.list &&
                        block?.acfBlockIconList?.list.length > 0 &&
                        block?.acfBlockIconList?.list.map((item, i) => {
                          return (
                            <div className="col-12 col-md-4 col-lg">
                              <Feature
                                img={item.icon && item.icon.mediaItemUrl}
                                title={item.title && item.title}
                                titleClassName="mb-2 mt-sm-down-1"
                                text={item.description && item.description}
                                key={i}
                              />
                            </div>
                          )
                        })}
                    </div>
                  </Container>
                </Section>
              )

              // case "acf/iconlist":
              //   const iconListBlock = iconList?.project?.blocks.find(
              //     item => item.name === "acf/iconlist"
              //   )
              //   return (
              //     <Section
              //       className={`${block.acfBlockIconList &&
              //         block.acfBlockIconList.bgColor} ${block.acfBlockIconList &&
              //         block.attributes.className}`}
              //     >
              //       <Container>
              //         <div className="mb-4">
              //           <h2 className="h2">
              //             {block.acfBlockIconList && block.acfBlockIconList.title}
              //           </h2>
              //           <p className="mb-0">
              //             {block.acfBlockIconList && block.acfBlockIconList.text}
              //           </p>
              //         </div>
              //         <div className="row mb-n2">
              //           {iconListBlock?.acfBlockIconList?.list &&
              //             iconListBlock?.acfBlockIconList?.list.length > 0 &&
              //             iconListBlock?.acfBlockIconList?.list.map((item, i) => {
              //               return (
              //                 <div className="col-12 col-md-4 col-lg">
              //                   <Feature
              //                     img={item.icon && item.icon.mediaItemUrl}
              //                     title={item.title && item.title}
              //                     titleClassName="mb-2 mt-sm-down-1"
              //                     text={item.description && item.description}
              //                     key={i}
              //                   />
              //                 </div>
              //               )
              //             })}
              //         </div>
              //       </Container>
              //     </Section>
              //   )

              {
                /* case "acf/instagram":
            return (
              <Instagram
                title={block.instagram.title}
                bgColor={block.instagram.bgColor}
                className={block.attributes.className}
              />
            ); */
              }

            case "acf/cover-content":
              return (
                <>
                  <CoverContent
                    theme="dark"
                    img={
                      block.coverContent &&
                      block.coverContent.img &&
                      block.coverContent.img.sourceUrl
                    }
                    imgOverlay="20"
                    className={`mb-n2 ${block.coverContent.bgColor ||
                      ""} ${block.attributes.className || ""}`}
                  >
                    <h2 className="h2">{block.coverContent.title || ""}</h2>
                    <p>{block.coverContent.text || ""}</p>
                    {block.coverContent.buttons && (
                      <ButtonGroup>
                        {block.coverContent.buttons.length > 0 &&
                          block.coverContent.buttons.map((item, i) => {
                            return (
                              <Button
                                variant="link"
                                link={item.link && item.link.url}
                                target={item.link && item.link.target}
                                key={i}
                              >
                                {item.text}
                              </Button>
                            )
                          })}
                      </ButtonGroup>
                    )}
                  </CoverContent>
                </>
              )
            case "core/shortcode":
              return (
                <Shortcodes
                  data={block}
                  key={`${block.name}${i}`}
                  nearbyData={nearbyData}
                  eBrochure={eBrochure}
                  name={wp.title}
                  lang={lang}
                  // eCatalogUrl={() => {props?.setAttentionModal(true)}}
                  projectData={wp}
                  propertyTypesProject={propertyTypesName}
                  contentIds={contentIds}
                  thisUrl={eCatalogProject?.url ? eCatalogProject?.url : "#"}
                />
              )
            case "acf/virtual-link":
              let links = []
              block.acfVirtualLink.cards.map(item => {
                links.push({
                  image: item.image && item.image.mediaItemUrl,
                  propertyName: "", //item.title,
                  description: item.description || null,
                  linkTo: item.link && item.link.url,
                  target: item.link && item.link.target,
                })
              })
              return (
                <Container
                  className="py-main px-sm-down-0 mb-md-3"
                  key={`virtual-link-${i}`}
                >
                  <h2 className="pb-3 px-sm-down-3">
                    {block.acfVirtualLink.title}
                  </h2>
                  <GliderVirtualLink data={links} />
                </Container>
              )
          }
        })}
      {lang === "ID" &&
        wpID === null &&
        wp.blocks.map((block, i) => {
          switch (block.name) {
            case "core/embed":
              return (
                <Cover
                  type={{ name: "core-embed/youtube" }}
                  theme="dark"
                  imgHeight="h-400px h-md-500px w-100"
                  imgOverlay="40"
                  className="cover cover-full-top"
                  videoSrc={block.attributes.url}
                  // imgOverlay="30"
                  // imgHeight="h-500px h-md-600px w-100"
                  // className="cover-full cover-main"
                />
              )
            case "acf/cover-main":
              return (
                <>
                  <div className="position-relative">
                    <AcfCoverMain
                      data={block}
                      key={`${block.name}${i}`}
                      breadcrumb={location.pathname}
                    />
                    <ButtonWADesktop onClick={()=>setIsOpenModalWA(true)} />
                  </div>
                  <section className="py-main pt-3 pb-3 bg-light social-dev-wrapper">
                    <div className="container">
                      <div className="row">
                        <div className="col-lg-12 col-xl-12">
                          <SocialShare link={thisUrl} onClick={handleCopy} />
                        </div>
                      </div>
                    </div>
                  </section>
                  <div>
                    <meta itemProp="mpn" content="925872" />
                    <meta itemProp="name" content={seo?.title} />
                    <link
                      itemProp="image"
                      href={block?.coverMain?.img?.mediaItemUrl}
                    />
                    <meta
                      itemProp="description"
                      content={seo?.opengraphDescription}
                    />
                    <div
                      itemProp="offers"
                      itemType="https://schema.org/AggregateOffer"
                      itemScope
                    >
                      <meta itemProp="lowPrice" content="0" />
                      <meta itemProp="highPrice" content="0" />
                      <meta itemProp="offerCount" content="10" />
                      <meta itemProp="priceCurrency" content="IDR" />
                    </div>
                    <div
                      itemProp="review"
                      itemType="https://schema.org/Review"
                      itemScope
                    >
                      <div
                        itemProp="author"
                        itemType="https://schema.org/Person"
                        itemScope
                      >
                        <meta itemProp="name" content="Sinar Mas Land" />
                      </div>
                      <div
                        itemProp="reviewRating"
                        itemType="https://schema.org/Rating"
                        itemScope
                      >
                        <meta itemProp="ratingValue" content="4.5" />
                        <meta itemProp="bestRating" content="5" />
                      </div>
                    </div>
                    <meta itemProp="sku" content="0446310786" />
                    <div
                      itemProp="brand"
                      itemType="https://schema.org/Brand"
                      itemScope
                    >
                      <meta itemProp="name" content="BSD City" />
                    </div>
                  </div>
                </>
              )

            case "acf/col-headline":
              return (
                <Section className="bg-light">
                  <Container className="">
                    <div className="row">
                      <div className="col-lg-6 col-xl-5 pr-4">
                        <h2 className="h2">
                          {block.colHeadline &&
                            block.colHeadline.title &&
                            replaceUnicode(block.colHeadline.title)}
                        </h2>
                      </div>
                      <div className="col-lg-6 col-xl-7">
                        <div className={`mb-3 ${isShowMore ? '' : 'line-clamp-3'}`}>
                          {
                            // block.colHeadline && block.colHeadline.text
                            <ReactMarkdown
                              source={block.colHeadline.text}
                              escapeHtml={false}
                            />
                          }
                        </div>
                        <button onClick={()=> setIsShowMore((prev)=>!prev)} className="btn btn-link text-secondary">
                          {isShowMore ? 'Hide' : 'Show More'}
                        </button>
                        {/* On FUTURE DEVELOPMENT details pages only */}
                        {block.colHeadline.additionalInfo != null ? (
                          <>
                            <div className="mt-5">
                              <p class="h4 mb-3 text-gray-600">
                                {block.colHeadline.additionalInfo[0].label}
                              </p>
                              <p>{block.colHeadline.additionalInfo[0].value}</p>
                            </div>
                            {block.colHeadline.buttons != null ? (
                              <Button
                                variant="link"
                                to={block.colHeadline.buttons[0].url}
                              >
                                {block.colHeadline.buttons[0].text}
                              </Button>
                            ) : null}
                          </>
                        ) : null}
                      </div>
                    </div>
                  </Container>
                </Section>
              )

            case "acf/image-slider":
              if (block.imageSlider && block.imageSlider.images !== null) {
                return (
                  <Section>
                    <Container>
                      <HeadingLink>
                        <h2 className="h3">
                          {block.imageSlider && block.imageSlider.title}
                        </h2>
                        <Button variant="link">
                          {block.imageSlider && block.imageSlider.link.text}
                        </Button>
                      </HeadingLink>
                      <CardSlider
                        showInitial={6}
                        showLgDown={5}
                        showMdDown={4}
                        showSmDown={3.5}
                      >
                        {block.imageSlider &&
                          block.imageSlider.images.length > 0 &&
                          block.imageSlider.images.map((item, i) => {
                            return (
                              <Card
                                variant="boxless"
                                img={item.img && item.img.mediaItemUrl}
                                imgHeight="h-ratio-1-1"
                              />
                            )
                          })}
                      </CardSlider>
                    </Container>
                  </Section>
                )
              }

            case "acf/acfgallery":
              return (
                <Section
                  className={`${block.acfBlockGallery &&
                    block.acfBlockGallery.bgColor} ${block.attributes &&
                    block.attributes.className}`}
                >
                  <Container className="px-sm-down-0">
                    <CardSlider
                      // fade
                      noGutter
                      showInitial={1}
                      showLgDown={1}
                      showMdDown={1}
                      showSmDown={1}
                      visibleInitial={false}
                      visibleLgDown={false}
                      arrowsLgDown={true}
                      arrowsMdDown={true}
                      arrowsSmDown={true}
                    >
                      {block.acfBlockGallery &&
                        block.acfBlockGallery.images &&
                        block.acfBlockGallery.images.map((item, i) => {
                          return (
                            <Card
                              variant="boxless"
                              img={item.sourceUrl}
                              imgHeight="h-ratio-2-1"
                              key={i}
                            />
                          )
                        })}
                    </CardSlider>
                  </Container>
                </Section>
              )

            case "acf/map-with-features":
              return (
                <>
                  <Section className="map-w-features p-0">
                    <div className="row row-0">
                      <div className="col-md-7">
                        <GoogleMapsEmbed
                          embedUrl={wp?.embedProjectsLocation?.embedUrl}
                        />
                        {/* <Map
                          long={
                            block.MapWFeatures.location &&
                            parseFloat(block.MapWFeatures.location.longitude)
                          }
                          lat={
                            block.MapWFeatures.location &&
                            parseFloat(block.MapWFeatures.location.latitude)
                          }
                          zoom={16}
                        /> */}
                      </div>
                      <div className="col-md-5 py-main-sm px-md-4 bg-secondary">
                        <Container className="features-top">
                          <h2 className="h2">
                            {block.MapWFeatures && block.MapWFeatures.title}
                          </h2>
                          <ul>
                            {block.MapWFeatures.featuresTop &&
                              block.MapWFeatures.featuresTop.map((item, i) => {
                                return (
                                  <li key={i}>
                                    <Feature
                                      title={item.name}
                                      text={item.text}
                                    />
                                  </li>
                                )
                              })}
                          </ul>
                        </Container>
                      </div>
                    </div>
                  </Section>
                  <Section>
                    <Container className="features-bottom">
                      <div className="row row-3">
                        {block.MapWFeatures.featuresBottom &&
                          block.MapWFeatures.featuresBottom.length > 0 &&
                          block.MapWFeatures.featuresBottom.map((item, i) => {
                            return (
                              <div className="col-md-6" key={i}>
                                <Feature title={item.name} text={item.text} />
                              </div>
                            )
                          })}
                      </div>
                    </Container>
                  </Section>
                </>
              )

            case "acf/iconlist":
              return (
                <Section
                  className={`${block.acfBlockIconList &&
                    block.acfBlockIconList.bgColor} ${block.acfBlockIconList &&
                    block.attributes.className}`}
                >
                  <Container>
                    <div className="mb-4">
                      <h2 className="h2">
                        {block.acfBlockIconList && block.acfBlockIconList.title}
                      </h2>
                      <p className="mb-0">
                        {block.acfBlockIconList && block.acfBlockIconList.text}
                      </p>
                    </div>
                    <div className="row mb-n2">
                      {block?.acfBlockIconList?.list &&
                        block?.acfBlockIconList?.list.length > 0 &&
                        block?.acfBlockIconList?.list.map((item, i) => {
                          return (
                            <div className="col-12 col-md-4 col-lg">
                              <Feature
                                img={item.icon && item.icon.mediaItemUrl}
                                title={item.title && item.title}
                                titleClassName="mb-2 mt-sm-down-1"
                                text={item.description && item.description}
                                key={i}
                              />
                            </div>
                          )
                        })}
                    </div>
                  </Container>
                </Section>
              )

              // case "acf/iconlist":
              //   const iconListBlock = iconList?.project?.blocks.find(
              //     item => item.name === "acf/iconlist"
              //   )
              //   return (
              //     <Section
              //       className={`${block.acfBlockIconList &&
              //         block.acfBlockIconList.bgColor} ${block.acfBlockIconList &&
              //         block.attributes.className}`}
              //     >
              //       <Container>
              //         <div className="mb-4">
              //           <h2 className="h2">
              //             {block.acfBlockIconList && block.acfBlockIconList.title}
              //           </h2>
              //           <p className="mb-0">
              //             {block.acfBlockIconList && block.acfBlockIconList.text}
              //           </p>
              //         </div>
              //         <div className="row mb-n2">
              //           {iconListBlock?.acfBlockIconList?.list &&
              //             iconListBlock?.acfBlockIconList?.list.length > 0 &&
              //             iconListBlock?.acfBlockIconList?.list.map((item, i) => {
              //               return (
              //                 <div className="col-12 col-md-4 col-lg">
              //                   <Feature
              //                     img={item.icon && item.icon.mediaItemUrl}
              //                     title={item.title && item.title}
              //                     titleClassName="mb-2 mt-sm-down-1"
              //                     text={item.description && item.description}
              //                     key={i}
              //                   />
              //                 </div>
              //               )
              //             })}
              //         </div>
              //       </Container>
              //     </Section>
              //   )

              {
                /* case "acf/instagram":
            return (
              <Instagram
                title={block.instagram.title}
                bgColor={block.instagram.bgColor}
                className={block.attributes.className}
              />
            ); */
              }

            case "acf/cover-content":
              return (
                <>
                  <CoverContent
                    theme="dark"
                    img={
                      block.coverContent &&
                      block.coverContent.img &&
                      block.coverContent.img.sourceUrl
                    }
                    imgOverlay="20"
                    className={`mb-n2 ${block.coverContent.bgColor ||
                      ""} ${block.attributes.className || ""}`}
                  >
                    <h2 className="h2">{block.coverContent.title || ""}</h2>
                    <p>{block.coverContent.text || ""}</p>
                    {block.coverContent.buttons && (
                      <ButtonGroup>
                        {block.coverContent.buttons.length > 0 &&
                          block.coverContent.buttons.map((item, i) => {
                            return (
                              <Button
                                variant="link"
                                link={item.link && item.link.url}
                                target={item.link && item.link.target}
                                key={i}
                              >
                                {item.text}
                              </Button>
                            )
                          })}
                      </ButtonGroup>
                    )}
                  </CoverContent>
                </>
              )
            case "core/shortcode":
              return (
                <Shortcodes
                  data={block}
                  key={`${block.name}${i}`}
                  nearbyData={nearbyData}
                  eBrochure={eBrochure}
                  name={wp.title}
                  lang={lang}
                  // eCatalogUrl={() => {props?.setAttentionModal(true)}}
                  projectData={wp}
                  propertyTypesProject={propertyTypesName}
                  contentIds={contentIds}
                  thisUrl={eCatalogProject?.url ? eCatalogProject?.url : "#"}
                />
              )
            case "acf/virtual-link":
              let links = []
              block.acfVirtualLink.cards.map(item => {
                links.push({
                  image: item.image && item.image.mediaItemUrl,
                  propertyName: "", //item.title,
                  description: item.description || null,
                  linkTo: item.link && item.link.url,
                  target: item.link && item.link.target,
                })
              })
              return (
                <Container
                  className="py-main px-sm-down-0 mb-md-3"
                  key={`virtual-link-${i}`}
                >
                  <h2 className="pb-3 px-sm-down-3">
                    {block.acfVirtualLink.title}
                  </h2>
                  <GliderVirtualLink data={links} />
                </Container>
              )
          }
        })}

      {lang === "EN" &&
        wp &&
        wp.blocks.map((block, i) => {
          switch (block.name) {
            case "core/embed":
              return (
                <Cover
                  type={{ name: "core-embed/youtube" }}
                  theme="dark"
                  imgHeight="h-400px h-md-500px w-100"
                  imgOverlay="40"
                  className="cover cover-full-top"
                  videoSrc={block.attributes.url}
                  // imgOverlay="30"
                  // imgHeight="h-500px h-md-600px w-100"
                  // className="cover-full cover-main"
                />
              )
            case "acf/cover-main":
              return (
                <>
                  <div className="position-relative">
                    <AcfCoverMain
                      data={block}
                      key={`${block.name}${i}`}
                      breadcrumb={location.pathname}
                    />
                    <ButtonWADesktop onClick={()=>setIsOpenModalWA(true)} />
                  </div>
                  <section className="py-main pt-3 pb-3 bg-light social-dev-wrapper">
                    <div className="container">
                      <div className="row">
                        <div className="col-lg-12 col-xl-12">
                          <SocialShare link={thisUrl} onClick={handleCopy} />
                        </div>
                      </div>
                    </div>
                  </section>
                  <div>
                    <meta itemProp="mpn" content="925872" />
                    <meta itemProp="name" content={seo?.title} />
                    <link
                      itemProp="image"
                      href={block?.coverMain?.img?.mediaItemUrl}
                    />
                    <meta
                      itemProp="description"
                      content={seo?.opengraphDescription}
                    />
                    <div
                      itemProp="offers"
                      itemType="https://schema.org/AggregateOffer"
                      itemScope
                    >
                      <meta itemProp="lowPrice" content="0" />
                      <meta itemProp="highPrice" content="0" />
                      <meta itemProp="offerCount" content="10" />
                      <meta itemProp="priceCurrency" content="IDR" />
                    </div>
                    <div
                      itemProp="review"
                      itemType="https://schema.org/Review"
                      itemScope
                    >
                      <div
                        itemProp="author"
                        itemType="https://schema.org/Person"
                        itemScope
                      >
                        <meta itemProp="name" content="Sinar Mas Land" />
                      </div>
                      <div
                        itemProp="reviewRating"
                        itemType="https://schema.org/Rating"
                        itemScope
                      >
                        <meta itemProp="ratingValue" content="4.5" />
                        <meta itemProp="bestRating" content="5" />
                      </div>
                    </div>
                    <meta itemProp="sku" content="0446310786" />
                    <div
                      itemProp="brand"
                      itemType="https://schema.org/Brand"
                      itemScope
                    >
                      <meta itemProp="name" content="BSD City" />
                    </div>
                  </div>
                </>
              )

            case "acf/col-headline":
              return (
                <Section className="bg-light">
                  <Container className="">
                    <div className="row">
                      <div className="col-lg-6 col-xl-5 pr-4">
                        <h2 className="h2">
                          {block.colHeadline &&
                            block.colHeadline.title &&
                            replaceUnicode(block.colHeadline.title)}
                        </h2>
                      </div>
                      <div className="col-lg-6 col-xl-7">
                        <div className={`mb-3 ${isShowMore ? '' : 'line-clamp-3'}`}>
                          {
                            // block.colHeadline && block.colHeadline.text
                            <ReactMarkdown
                              source={block.colHeadline.text}
                              escapeHtml={false}
                            />
                          }
                        </div>
                        <button onClick={()=> setIsShowMore((prev)=>!prev)} className="btn btn-link text-secondary">
                          {isShowMore ? 'Hide' : 'Show More'}
                        </button>
                        {/* On FUTURE DEVELOPMENT details pages only */}
                        {block.colHeadline.additionalInfo != null ? (
                          <>
                            <div className="mt-5">
                              <p class="h4 mb-3 text-gray-600">
                                {block.colHeadline.additionalInfo[0].label}
                              </p>
                              <p>{block.colHeadline.additionalInfo[0].value}</p>
                            </div>
                            {block.colHeadline.buttons != null ? (
                              <Button
                                variant="link"
                                to={block.colHeadline.buttons[0].url}
                              >
                                {block.colHeadline.buttons[0].text}
                              </Button>
                            ) : null}
                          </>
                        ) : null}
                      </div>
                    </div>
                  </Container>
                </Section>
              )

            case "acf/image-slider":
              if (block.imageSlider && block.imageSlider.images !== null) {
                return (
                  <Section>
                    <Container>
                      <HeadingLink>
                        <h2 className="h3">
                          {block.imageSlider && block.imageSlider.title}
                        </h2>
                        <Button variant="link">
                          {block.imageSlider && block.imageSlider.link.text}
                        </Button>
                      </HeadingLink>
                      <CardSlider
                        showInitial={6}
                        showLgDown={5}
                        showMdDown={4}
                        showSmDown={3.5}
                      >
                        {block.imageSlider &&
                          block.imageSlider.images.length > 0 &&
                          block.imageSlider.images.map((item, i) => {
                            return (
                              <Card
                                variant="boxless"
                                img={item.img && item.img.mediaItemUrl}
                                imgHeight="h-ratio-1-1"
                              />
                            )
                          })}
                      </CardSlider>
                    </Container>
                  </Section>
                )
              }

            case "acf/acfgallery":
              return (
                <Section
                  className={`${block.acfBlockGallery &&
                    block.acfBlockGallery.bgColor} ${block.attributes &&
                    block.attributes.className}`}
                >
                  <Container className="px-sm-down-0">
                    <CardSlider
                      // fade
                      noGutter
                      showInitial={1}
                      showLgDown={1}
                      showMdDown={1}
                      showSmDown={1}
                      visibleInitial={false}
                      visibleLgDown={false}
                      arrowsLgDown={true}
                      arrowsMdDown={true}
                      arrowsSmDown={true}
                    >
                      {block.acfBlockGallery &&
                        block.acfBlockGallery.images &&
                        block.acfBlockGallery.images.map((item, i) => {
                          return (
                            <Card
                              variant="boxless"
                              img={item.sourceUrl}
                              imgHeight="h-ratio-2-1"
                              key={i}
                            />
                          )
                        })}
                    </CardSlider>
                  </Container>
                </Section>
              )

            case "acf/map-with-features":
              return (
                <>
                  <Section className="map-w-features p-0">
                    <div className="row row-0">
                      <div className="col-md-7">
                        <GoogleMapsEmbed
                          embedUrl={wp?.embedProjectsLocation?.embedUrl}
                        />
                        {/* <Map
                          long={
                            block.MapWFeatures.location &&
                            parseFloat(block.MapWFeatures.location.longitude)
                          }
                          lat={
                            block.MapWFeatures.location &&
                            parseFloat(block.MapWFeatures.location.latitude)
                          }
                          zoom={16}
                        /> */}
                      </div>
                      <div className="col-md-5 py-main-sm px-md-4 bg-secondary">
                        <Container className="features-top">
                          <h2 className="h2">
                            {block.MapWFeatures && block.MapWFeatures.title}
                          </h2>
                          <ul>
                            {block.MapWFeatures.featuresTop &&
                              block.MapWFeatures.featuresTop.map((item, i) => {
                                return (
                                  <li key={i}>
                                    <Feature
                                      title={item.name}
                                      text={item.text}
                                    />
                                  </li>
                                )
                              })}
                          </ul>
                        </Container>
                      </div>
                    </div>
                  </Section>
                  <Section>
                    <Container className="features-bottom">
                      <div className="row row-3">
                        {block.MapWFeatures.featuresBottom &&
                          block.MapWFeatures.featuresBottom.length > 0 &&
                          block.MapWFeatures.featuresBottom.map((item, i) => {
                            return (
                              <div className="col-md-6" key={i}>
                                <Feature title={item.name} text={item.text} />
                              </div>
                            )
                          })}
                      </div>
                    </Container>
                  </Section>
                </>
              )

            case "acf/iconlist":
              return (
                <Section
                  className={`${block.acfBlockIconList &&
                    block.acfBlockIconList.bgColor} ${block.acfBlockIconList &&
                    block.attributes.className}`}
                >
                  <Container>
                    <div className="mb-4">
                      <h2 className="h2">
                        {block.acfBlockIconList && block.acfBlockIconList.title}
                      </h2>
                      <p className="mb-0">
                        {block.acfBlockIconList && block.acfBlockIconList.text}
                      </p>
                    </div>
                    <div className="row mb-n2">
                      {block?.acfBlockIconList?.list &&
                        block?.acfBlockIconList?.list.length > 0 &&
                        block?.acfBlockIconList?.list.map((item, i) => {
                          return (
                            <div className="col-12 col-md-4 col-lg">
                              <Feature
                                img={item.icon && item.icon.mediaItemUrl}
                                title={item.title && item.title}
                                titleClassName="mb-2 mt-sm-down-1"
                                text={item.description && item.description}
                                key={i}
                              />
                            </div>
                          )
                        })}
                    </div>
                  </Container>
                </Section>
              )

              // case "acf/iconlist":
              //   const iconListBlock = iconList?.project?.blocks.find(
              //     item => item.name === "acf/iconlist"
              //   )
              //   return (
              //     <Section
              //       className={`${block.acfBlockIconList &&
              //         block.acfBlockIconList.bgColor} ${block.acfBlockIconList &&
              //         block.attributes.className}`}
              //     >
              //       <Container>
              //         <div className="mb-4">
              //           <h2 className="h2">
              //             {block.acfBlockIconList && block.acfBlockIconList.title}
              //           </h2>
              //           <p className="mb-0">
              //             {block.acfBlockIconList && block.acfBlockIconList.text}
              //           </p>
              //         </div>
              //         <div className="row mb-n2">
              //           {iconListBlock?.acfBlockIconList?.list &&
              //             iconListBlock?.acfBlockIconList?.list.length > 0 &&
              //             iconListBlock?.acfBlockIconList?.list.map((item, i) => {
              //               return (
              //                 <div className="col-12 col-md-4 col-lg">
              //                   <Feature
              //                     img={item.icon && item.icon.mediaItemUrl}
              //                     title={item.title && item.title}
              //                     titleClassName="mb-2 mt-sm-down-1"
              //                     text={item.description && item.description}
              //                     key={i}
              //                   />
              //                 </div>
              //               )
              //             })}
              //         </div>
              //       </Container>
              //     </Section>
              //   )

              {
                /* case "acf/instagram":
              return (
                <Instagram
                  title={block.instagram.title}
                  bgColor={block.instagram.bgColor}
                  className={block.attributes.className}
                />
              ); */
              }

            case "acf/cover-content":
              return (
                <>
                  <CoverContent
                    theme="dark"
                    img={
                      block.coverContent &&
                      block.coverContent.img &&
                      block.coverContent.img.sourceUrl
                    }
                    imgOverlay="20"
                    className={`mb-n2 ${block.coverContent.bgColor ||
                      ""} ${block.attributes.className || ""}`}
                  >
                    <h2 className="h2">{block.coverContent.title || ""}</h2>
                    <p>{block.coverContent.text || ""}</p>
                    {block.coverContent.buttons && (
                      <ButtonGroup>
                        {block.coverContent.buttons.length > 0 &&
                          block.coverContent.buttons.map((item, i) => {
                            return (
                              <Button
                                variant="link"
                                link={item.link && item.link.url}
                                target={item.link && item.link.target}
                                key={i}
                              >
                                {item.text}
                              </Button>
                            )
                          })}
                      </ButtonGroup>
                    )}
                  </CoverContent>
                </>
              )
            case "core/shortcode":
              return (
                <Shortcodes
                  data={block}
                  key={`${block.name}${i}`}
                  nearbyData={nearbyData}
                  eBrochure={eBrochure}
                  name={wp.title}
                  lang={lang}
                  // eCatalogUrl={() => {props?.setAttentionModal(true)}}
                  projectData={wp}
                  propertyTypesProject={propertyTypesName}
                  contentIds={contentIds}
                  thisUrl={eCatalogProject?.url ? eCatalogProject?.url : "#"}
                />
              )
            case "acf/virtual-link":
              let links = []
              block.acfVirtualLink &&
                block.acfVirtualLink.cards &&
                block.acfVirtualLink.cards.map(item => {
                  links.push({
                    image: item.image && item.image.mediaItemUrl,
                    propertyName: "", //item.title,
                    description: item.description || null,
                    linkTo: item.link && item.link.url,
                    target: item.link && item.link.target,
                  })
                })
              return (
                <Container
                  className="py-main px-sm-down-0 mb-md-3"
                  key={`virtual-link-${i}`}
                >
                  <h2 className="pb-3 px-sm-down-3">
                    {block.acfVirtualLink.title}
                  </h2>
                  <GliderVirtualLink data={links} />
                </Container>
              )
          }
        })}

      {/* {currentType && projectsByType && projectsByType.length > 2 && (
        <NavBottom
          data={projectsByType}
          slug={slug}
          prevTitle={prevProject() && prevProject().title}
          prevImg={
            (prevProject() &&
              prevProject().blocks.length > 0 &&
              prevProject().blocks[0].coverMain.img &&
              prevProject().blocks[0].coverMain.img.mediaItemUrl) ||
            data.imgCover.childImageSharp.fluid
          }
          prevLink={`/development/${currentType}/${(prevProject() && prevProject().slug) ||
            ""}`}
          nextTitle={nextProject() && nextProject().title}
          nextImg={
            (nextProject() &&
              nextProject().blocks.length > 0 &&
              nextProject().blocks[0].coverMain.img &&
              nextProject().blocks[0].coverMain.img.mediaItemUrl) ||
            data.imgCover.childImageSharp.fluid
          }
          nextLink={`/development/${currentType}/${(nextProject() && nextProject().slug) ||
            ""}`}
        />
      )} */}
      {currentType && projectsByType && projectsByType.length > 2 && (
        <NavBottom
          lang={lang}
          data={projectsByType}
          slug={slug}
          prevTitle={prevProject() && prevProject().title}
          prevImg={
            (prevProject() &&
              prevProject().blocks.length > 0 &&
              prevProject()?.blocks[0]?.coverMain?.img &&
              prevProject()?.blocks[0]?.coverMain?.img?.mediaItemUrl) ||
            data?.imgCover?.childImageSharp?.fluid
          }
          prevLink={`/development/${currentType}/${(prevProject() &&
            prevProject().slug) ||
            ""}`}
          nextTitle={nextProject() && nextProject().title}
          nextImg={
            (nextProject() &&
              nextProject()?.blocks?.length > 0 &&
              nextProject()?.blocks[0]?.coverMain?.img &&
              nextProject()?.blocks[0]?.coverMain?.img?.mediaItemUrl) ||
            data?.imgCover?.childImageSharp?.fluid
          }
          nextLink={`/development/${currentType}/${(nextProject() &&
            nextProject().slug) ||
            ""}`}
        />
      )}
      <Modal
        // overlayClassName="d-md-fixed d-none"
        isOpen={isOpenModalWA}
        onRequestClose={handleCloseModalWA}
        style={customStyles}
        contentLabel="WA form"
      >
        <div className="modal-popup-home modal-body">
          <div className="popup-close">
            <i className="fal fa-times" onClick={handleCloseModalWA}></i>
          </div>
          <Container className={'py-4'}>
            <GetMoreInfoForm 
              propertyName={wp?.title}
              clusterCode={clusterCode} 
              leadSourceName={leadSourceName} 
              projectsCode={projectsCode} 
              onSuccess={(values)=>{
                console.log('success', values)
                const message = `Hi, saya ingin info promo produk ${propertyTypesName} ${wp?.title}. 

Saya dengan: 

Terima Kasih! 

BSDWebsite, LSN: CAM-Performance-Development-Info-Promosi-${propertyTypesName}-${wp?.title}-BSDWebsite`
                const url = `https://api.whatsapp.com/send?phone=628811382862&text=${encodeURIComponent(message)}`;
                setTimeout(async () => {
                  setIsOpenModalWA(false)
                  await handleOpenWA(url)
                  navigate(`/thankyou`)
                }, 1500)
              }} 
            />
          </Container>
        </div>
      </Modal>
      <CDPTracker 
        email={loginEmail}
        mobile={loginMobile}
        C4CID={loginC4CID}
        lastName={lastName}
        clusterCode={wp.projectCustomfields.clusterCode} 
        projectName={wp.title} 
      />
    </Layout>
    <div className="fixed-bottom w-100 d-block d-md-none">
      <button 
        onClick={()=>setIsOpenModalWA(true)} 
        className="btn btn-primary d-flex align-items-center w-100 justify-content-center" 
        style={{
          gap: '4px',
          backgroundColor: "#203091",
          color: "white",
          border: "none",
          boxShadow: "0 8px 20px rgba(0,0,0,0.45)"
        }}>
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M19.05 4.91A9.82 9.82 0 0 0 12.04 2c-5.46 0-9.91 4.45-9.91 9.91c0 1.75.46 3.45 1.32 4.95L2.05 22l5.25-1.38c1.45.79 3.08 1.21 4.74 1.21c5.46 0 9.91-4.45 9.91-9.91c0-2.65-1.03-5.14-2.9-7.01m-7.01 15.24c-1.48 0-2.93-.4-4.2-1.15l-.3-.18l-3.12.82l.83-3.04l-.2-.31a8.26 8.26 0 0 1-1.26-4.38c0-4.54 3.7-8.24 8.24-8.24c2.2 0 4.27.86 5.82 2.42a8.18 8.18 0 0 1 2.41 5.83c.02 4.54-3.68 8.23-8.22 8.23m4.52-6.16c-.25-.12-1.47-.72-1.69-.81c-.23-.08-.39-.12-.56.12c-.17.25-.64.81-.78.97c-.14.17-.29.19-.54.06c-.25-.12-1.05-.39-1.99-1.23c-.74-.66-1.23-1.47-1.38-1.72c-.14-.25-.02-.38.11-.51c.11-.11.25-.29.37-.43s.17-.25.25-.41c.08-.17.04-.31-.02-.43s-.56-1.34-.76-1.84c-.2-.48-.41-.42-.56-.43h-.48c-.17 0-.43.06-.66.31c-.22.25-.86.85-.86 2.07s.89 2.4 1.01 2.56c.12.17 1.75 2.67 4.23 3.74c.59.26 1.05.41 1.41.52c.59.19 1.13.16 1.56.1c.48-.07 1.47-.6 1.67-1.18c.21-.58.21-1.07.14-1.18s-.22-.16-.47-.28"/></svg>
        <span>Whatsapp</span>
      </button>
    </div>
    </>
  )
}

export default DevelopmentDetails
